class Cliente{
    constructor(id, nombre, numero_documento, domicilio, localidad, codigo_postal, responsabilidad_iva_id, telefono, lista_id, user_id){
        this.id = id;
        this.nombre = nombre;
        this.numero_documento = numero_documento;
        this.domicilio = domicilio;
        this.localidad = localidad;
        this.codigo_postal = codigo_postal;
        this.responsabilidad_iva_id = responsabilidad_iva_id;
        this.telefono = telefono;
        this.lista_id = lista_id;
        this.user_id = user_id;
    }
}
export default Cliente;
